export default __webpack_public_path__ + "static/media/edit-icon-fill.97ee08ac.svg";